import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import EN from '../resources/locales/en.json';
import FR from '../resources/locales/fr.json';

const detectionOptions = {
    // Order and from where user language should be detected
    order: ['path', 'navigator'],

    // Keys or params to lookup language from
    lookupFromPathIndex: 0,

    // Cache user language on
    caches: ['cookie'],

    // Only detect languages that are in the whitelist
    checkWhitelist: true
};

i18n.use(initReactI18next)
    .use(new LanguageDetector(null, detectionOptions))
    .init({
        fallbackLng: 'en',
        debug: true,
        supportedLngs: ['en', 'fr'],
        interpolation: {
            escapeValue: false
        },
        resources: {
            en: {
                translation: EN
            },
            fr: {
                translation: FR
            }
        }
    });

export default i18n;
